function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.91583 2.69997C8.91583 3.39583 9.47993 3.95993 10.1758 3.95993C10.8716 3.95993 11.4357 3.39583 11.4357 2.69997L8.91583 2.69997ZM11.0667 1.10908C10.5747 0.617037 9.7769 0.617037 9.28486 1.10908L1.26657 9.12737C0.774532 9.61941 0.774532 10.4172 1.26657 10.9092C1.75862 11.4012 2.55637 11.4012 3.04842 10.9092L10.1758 3.78184L17.3031 10.9092C17.7952 11.4012 18.5929 11.4012 19.085 10.9092C19.577 10.4172 19.577 9.61941 19.085 9.12737L11.0667 1.10908ZM11.4357 2.69997V2L8.91583 2V2.69997L11.4357 2.69997Z",
  fill: "white"
});

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.45b374fb.svg";
export { ForwardRef as ReactComponent };